import script from "./Paginator.vue?vue&type=script&lang=ts&setup=true"
export * from "./Paginator.vue?vue&type=script&lang=ts&setup=true"

import "./Paginator.vue?vue&type=style&index=0&id=7761905e&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/curl-fe-build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7761905e"]])

export default __exports__